module.exports = __webpack_public_path__ + "img/example.c8551df8.svg";